export enum SedsColorMode {
  DEFAULT_LIGHT = 'default-light',
  DEFAULT_DARK = 'default-dark',
  PRIMARY_LIGHT = 'primary-light',
  PRIMARY_DARK = 'primary-dark',
}
